export default "__VITE_ASSET__CUiItc9l__"